import { useFedStore, useL } from '../store';
import { LIVE_DEFAULTS } from '../data';
import { useFedContent } from '../content';
import { Ic } from '../icons';
import { Rv, Eyebrow } from '../ui';

const TWITCH_URL = 'https://www.twitch.tv/cybersqo';

const COPY = {
  ru: {
    title: 'Эфиры федерации',
    subtitle: 'Здесь будут проходить прямые трансляции турниров, матчей и событий Федерации киберспорта Северо-Казахстанской области.',
    channel: 'Официальный канал федерации',
    offline: 'Сейчас эфир не идёт',
    hint: 'Когда начнётся следующая трансляция, мы сообщим об этом на сайте и в социальных сетях.',
    open: 'Открыть Twitch',
    window: 'Перейти на канал',
    status: 'Ближайший эфир',
    noDate: 'Дата пока не объявлена',
    noDateText: 'Расписание появится здесь после анонса следующего турнира.',
    follow: 'Подпишитесь на канал, чтобы Twitch заранее уведомил вас о начале трансляции.',
    archive: 'Записи трансляций',
    archiveText: 'Записи прошедших матчей и турниров публикуются на YouTube-канале федерации.',
    youtube: 'Открыть YouTube',
  },
  kz: {
    title: 'Федерация эфирлері',
    subtitle: 'Мұнда Солтүстік Қазақстан облысының киберспорт федерациясы турнирлерінің, матчтары мен іс-шараларының тікелей көрсетілімдері өтеді.',
    channel: 'Федерацияның ресми арнасы',
    offline: 'Қазір эфир жоқ',
    hint: 'Келесі трансляция басталғанда, бұл туралы сайтта және әлеуметтік желілерде хабарлаймыз.',
    open: 'Twitch-ті ашу',
    window: 'Арнаға өту',
    status: 'Келесі эфир',
    noDate: 'Күні әлі жарияланған жоқ',
    noDateText: 'Кесте келесі турнир жарияланғаннан кейін осында шығады.',
    follow: 'Трансляцияның басталғаны туралы алдын ала хабарлама алу үшін арнаға жазылыңыз.',
    archive: 'Трансляция жазбалары',
    archiveText: 'Өткен матчтар мен турнирлердің жазбалары федерацияның YouTube арнасында жарияланады.',
    youtube: 'YouTube-ты ашу',
  },
};

const RED = {
  bright: '#ff3037',
  accent: '#e11217',
  deep: '#72080c',
  line: 'rgba(255,64,70,.38)',
  glow: 'rgba(225,18,23,.46)',
  soft: 'rgba(225,18,23,.12)',
};

export default function FedLive() {
  const lang = useFedStore((state) => state.lang);
  const L = useL();
  const live = useFedContent((state) => state.live) || LIVE_DEFAULTS;
  const youtubeUrl = live.youtube || LIVE_DEFAULTS.youtube;
  const T = COPY[lang === 'kz' ? 'kz' : 'ru'];

  return (
    <div className="fed-pagewrap max-w-[1320px] mx-auto" style={{ padding: '52px 24px 80px' }}>
      <Rv style={{ marginBottom: 28 }}>
        <Eyebrow className="flex items-center gap-2" style={{ marginBottom: 12 }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--fed-fg-faint)' }} />
          {L.nav_live}
        </Eyebrow>
        <h1 style={{ fontSize: 'clamp(38px,6vw,68px)' }}>{T.title}</h1>
        <p className="max-w-[720px] text-fg-soft" style={{ marginTop: 14, fontSize: 16, lineHeight: 1.65 }}>{T.subtitle}</p>
      </Rv>

      <div className="fed-split-2" style={{ gridTemplateColumns: '1.55fr .85fr' }}>
        <Rv className="flex flex-col gap-4">
          <div className="flex items-center gap-2.5 flex-wrap">
            <span className="inline-flex items-center gap-2 rounded-full font-mono uppercase text-white" style={{ padding: '7px 12px', fontSize: 10.5, letterSpacing: '.1em', background: `linear-gradient(120deg,${RED.bright},${RED.deep})`, boxShadow: `0 9px 22px -12px ${RED.glow}` }}>
              <Ic name="twitch" size={14} /> Twitch
            </span>
            <span className="font-display font-bold text-fg" style={{ fontSize: 16 }}>{T.channel}</span>
            <span className="font-mono text-fg-faint" style={{ fontSize: 11 }}>twitch.tv/cybersqo</span>
          </div>

          <a
            href={TWITCH_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative block overflow-hidden rounded-[20px] border no-underline"
            style={{
              aspectRatio: '16/9',
              borderColor: RED.line,
              boxShadow: `0 28px 70px -38px ${RED.glow}`,
              background: `radial-gradient(circle at 50% 115%,${RED.soft},transparent 48%),radial-gradient(circle at 18% 0%,rgba(255,48,55,.2),transparent 38%),repeating-linear-gradient(135deg,transparent 0 30px,rgba(255,255,255,.012) 30px 31px),linear-gradient(150deg,#1d0a0d,#09090b 65%)`,
            }}
          >
            <span className="absolute inline-flex items-center gap-2 rounded-full font-mono uppercase" style={{ top: 16, left: 16, padding: '7px 12px', fontSize: 9.5, letterSpacing: '.12em', color: 'var(--fed-fg-soft)', border: '1px solid var(--fed-line-2)', background: 'rgba(7,7,9,.62)' }}>
              <span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--fed-fg-faint)' }} /> {T.offline}
            </span>
            <span className="absolute inline-flex items-center gap-2 rounded-full font-mono text-fg-soft border border-line" style={{ top: 16, right: 16, padding: '7px 12px', fontSize: 10.5, background: 'rgba(6,6,8,.56)' }}>
              <Ic name="twitch" size={13} /> cybersqo
            </span>

            <span className="absolute inset-0 flex flex-col items-center justify-center gap-5" style={{ padding: 24, textAlign: 'center' }}>
              <span className="relative rounded-[28px] flex items-center justify-center transition-transform group-hover:scale-105" style={{ width: 96, height: 96, color: '#fff', background: `linear-gradient(145deg,${RED.bright},${RED.deep})`, boxShadow: `0 24px 56px -18px ${RED.glow}` }}>
                <Ic name="twitch" size={42} />
                <span className="absolute rounded-[34px]" style={{ inset: -10, border: `1px solid ${RED.line}` }} />
              </span>
              <span className="font-display font-bold uppercase text-white" style={{ fontSize: 'clamp(18px,2.4vw,28px)', letterSpacing: '.04em' }}>{T.window}</span>
              <span className="text-fg-muted" style={{ maxWidth: 470, fontSize: 12.5, lineHeight: 1.55 }}>{T.hint}</span>
            </span>
          </a>

          <div className="rounded-2xl bg-surface border border-line" style={{ padding: 20 }}>
            <p className="text-fg-muted" style={{ fontSize: 13.5, lineHeight: 1.65, marginBottom: 15 }}>{T.follow}</p>
            <a href={TWITCH_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 h-11 px-5 rounded-[11px] no-underline font-display font-bold uppercase text-white" style={{ fontSize: 13, background: `linear-gradient(120deg,${RED.bright},${RED.deep})`, boxShadow: `0 12px 28px -14px ${RED.glow}` }}>
              <Ic name="twitch" size={17} /> {T.open}<Ic name="external" size={14} />
            </a>
          </div>
        </Rv>

        <Rv delay={0.08} className="flex flex-col gap-4">
          <div className="rounded-2xl bg-surface border border-line" style={{ padding: 22 }}>
            <div className="font-mono uppercase text-fg-muted" style={{ fontSize: 10, letterSpacing: '.2em' }}>{T.status}</div>
            <div style={{ marginTop: 20, padding: '19px 0', borderTop: '1px solid var(--fed-line)', borderBottom: '1px solid var(--fed-line)' }}>
              <span className="inline-flex items-center gap-2 font-mono uppercase" style={{ color: 'var(--fed-fg-muted)', fontSize: 9 }}>
                <Ic name="calendar" size={15} /> {T.offline}
              </span>
              <h2 style={{ marginTop: 12, fontSize: 26 }}>{T.noDate}</h2>
              <p className="text-fg-muted" style={{ marginTop: 10, fontSize: 13, lineHeight: 1.6 }}>{T.noDateText}</p>
            </div>
          </div>

          <div className="rounded-2xl" style={{ padding: 22, background: `linear-gradient(140deg,${RED.soft},var(--fed-surface) 58%)`, border: `1px solid ${RED.line}` }}>
            <div className="flex items-center gap-2 font-display font-bold text-fg" style={{ fontSize: 19 }}><Ic name="youtube" size={20} />{T.archive}</div>
            <p className="text-fg-muted" style={{ fontSize: 13, lineHeight: 1.6, marginTop: 9, marginBottom: 16 }}>{T.archiveText}</p>
            <a href={youtubeUrl} target="_blank" rel="noopener noreferrer" className="inline-flex h-[42px] items-center px-[18px] rounded-[10px] bg-surface-2 border border-line-2 font-display font-semibold uppercase gap-2 no-underline" style={{ fontSize: 13, color: 'var(--fed-fg)' }}>
              <Ic name="youtube" size={18} /> {T.youtube}
            </a>
          </div>
        </Rv>
      </div>
    </div>
  );
}
